<template>
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.4709 4.58329L7.77092 0.866618C7.63758 0.733284 7.47092 0.666626 7.30425 0.666626H1.00425C0.637585 0.666626 0.337585 0.966626 0.337585 1.33329V14.6666C0.337585 15.0333 0.637585 15.3333 1.00425 15.3333H11.0043C11.3709 15.3333 11.6709 15.0333 11.6709 14.6666V5.04997C11.6709 4.86663 11.6043 4.69996 11.4709 4.58329ZM10.3376 5.33329H7.00425V1.99996H7.03759L10.3376 5.33329ZM1.67092 14V1.99996H5.67092V5.9833C5.67092 6.34996 5.95426 6.66663 6.32092 6.66663H10.3376V14H1.67092Z" fill="#109CF1"/>
  </svg>
</template>

<script>
export default {
  name: "fileIcon"
}
</script>
